import { useNizza } from '../../nizza-store';
import { AccountStatus } from '../../types';
import { NizzaAccount, PrivateNizzaAccount } from '../core';

interface UseAccountReturn<T = NizzaAccount> {
  account: T | undefined;
  accountName: string | undefined;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  accountStatus: AccountStatus;
  refetchAccount: () => Promise<void>;
  isPvtAccount: (
    account: NizzaAccount | PrivateNizzaAccount | undefined,
  ) => account is PrivateNizzaAccount;
  isPubAccount: (
    account: NizzaAccount | PrivateNizzaAccount | undefined,
  ) => account is NizzaAccount;
}

export const useAccount = <T = NizzaAccount>(): UseAccountReturn<T> => {
  const {
    account,
    accountName,
    accountStatus,
    refetchAccount,
    isPvtAccount,
    isPubAccount,
  } = useNizza(x => ({
    account: x.account as T | undefined,
    accountName: x.accountName,
    accountStatus: x.accountStatus,
    refetchAccount: x.refetchAccount,
    isPvtAccount: x.isPvtAccount,
    isPubAccount: x.isPubAccount,
  }));

  const isLoading = ['idle', 'loading'].includes(accountStatus);
  const isError = accountStatus === 'error';
  const isSuccess = accountStatus === 'success';

  return {
    account,
    accountName,
    isLoading,
    isError,
    isSuccess,
    accountStatus,
    refetchAccount,
    isPvtAccount,
    isPubAccount,
  };
};
